import {
  Button, Card, Form, Input, notification, Select, Upload, DatePicker,
  Row,
  Col,
} from 'antd';
import {
  InboxOutlined,
  DownloadOutlined,
  DeleteOutlined,
} from '@ant-design/icons';
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Smeta from './Smeta';
import Plan from './Plan';
import { numberToWords } from '../../../../utils/numberToWords';
import { updateCoexecutorProject } from '../../../../utils/http';


const { TextArea } = Input;
const { Option } = Select;
const { Dragger } = Upload;

function parseJsonResponse(key, json) {
  if (!json || typeof json !== 'string') return null;

  const data = JSON.parse(json);
  return data?.[key];
}

const getWordedNumber = (major) => {
  const summ = `${numberToWords(major)}`;
  const firstLetter = summ.charAt(0);
  const firstLetterCap = firstLetter.toUpperCase();
  const remainingLetters = summ.slice(1);

  return `${firstLetterCap}${remainingLetters}`;
};


export const SProject = ({ coexecutorData, formRef, onSaveForm }) => {
  const [loading, setLoading] = useState(false);
  const [osnovanieFile, setOsnovanieFile] = useState(
    coexecutorData?.osnovanieFile,
  );
  const [organizationCardFile, setOrganizationCardFile] = useState(
    coexecutorData?.organizationCardFile,
  );
  const [osnovanieName, setOsnovanieName] = useState(coexecutorData?.osnovanie);
  const [workType, setWorkType] = useState(coexecutorData?.workType);

  const parseAgreementDate = () => {
    const day = coexecutorData?.date_day;
    const month = coexecutorData?.date_month;
    const year = coexecutorData?.date_year;

    if (day && month && year) {
      const fullDate = moment(`${year}-${month}-${day}`, 'YYYY-MMMM-DD');

      if (!fullDate.isValid()) {
        return moment();
      }

      return fullDate;
    }

    return moment();
  };

  const onUploadFile = async (file) => {
    if (file.file.status === 'uploading' && !file.event) {
      const form = new FormData();
      const headers = {
        'Content-Type': 'multipart/form-data',
      };
      form.append('osnovanieFile', file.file.originFileObj);
      form.append('id', coexecutorData.id);
      // form.append('application2_id', coexecutorData.application2_id);
      setOsnovanieFile(file.file.originFileObj);
      await updateCoexecutorProject(form, headers);
    }
  };


  const onUploadOrganizationCardFile = async (file) => {
    if (file.file.status === 'uploading' && !file.event) {
      const form = new FormData();
      const headers = {
        'Content-Type': 'multipart/form-data',
      };
      form.append('organizationCardFile', file.file.originFileObj);
      form.append('id', coexecutorData.id);
      // form.append('application2_id', coexecutorData.application2_id);
      setOrganizationCardFile(file.file.originFileObj);
      await updateCoexecutorProject(form, headers);
    }
  };

  const onDeleteFile = async () => {
    try {
      await updateCoexecutorProject({
        id: coexecutorData.id,
        osnovanieFile: null,
      });
    } catch (e) {
      notification.error({
        message: 'Произошла. Попробуйте еще раз',
      });
    }

    setOsnovanieFile(null);
  };

  const onDeleteOrganizationCardFile = async () => {
    try {
      await updateCoexecutorProject({
        id: coexecutorData.id,
        // application: coexecutorData.application2_id,
        organizationCardFile: null,
      });
    } catch (e) {
      notification.error({
        message: 'Произошла. Попробуйте еще раз',
      });
    }
  };

  return (
    <Card
      style={{
        width: '100%',
        borderRadius: '15px',
        marginTop: '20px',
        height: '100%',
      }}
    >
      <div className="shortTab-wrapper">
        <Form.Item name="id" initialValue={coexecutorData?.id} hidden />

        <div className="common-subTitle" style={{ fontSize: '20px' }}>
          <b>
            Краткие сведения о Грантополучателе для генерации Соглашения
            на предоставление гранта
          </b>
        </div>

        <div className="common-table-row">
          <div
            className="common-table-row-cell"
            style={{ borderBottom: '1px solid #d9d9d9' }}
          >
            Дата заключения основного Соглашения.
          </div>
          <Form.Item
            style={{ width: '100%' }}
            name="agreement_date"
            initialValue={parseAgreementDate()}
          >
            <DatePicker format="DD MMMM YYYY" />
          </Form.Item>
        </div>

        <div className="common-table-wrapper">
          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{
                borderRight: '1px solid #d9d9d9',
                borderBottom: '1px solid #d9d9d9',
              }}
            >
              Должность лица, уполномоченного на право подписи, в
              {' '}
              <b>родительном падеже</b>
              {' '}
              (указывается со строчной буквы)
            </div>
            <Form.Item
              style={{ width: '100%' }}
              name="directorPositionRod"
              initialValue={coexecutorData?.directorPositionRod || coexecutorData.coexecutorsPersonId.directorPosition?.toLowerCase()}
            >
              <TextArea autoSize />
            </Form.Item>
          </div>
          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{
                borderRight: '1px solid #d9d9d9',
                borderBottom: '1px solid #d9d9d9',
              }}
            >
              ФИО лица, уполномоченного на право подписи, в
              {' '}
              <b>родительном падеже</b>
            </div>
            <Form.Item
              style={{ width: '100%' }}
              name="directorFullNameRod"
              initialValue={coexecutorData?.directorFullNameRod || coexecutorData.coexecutorsPersonId.directorFullName}
            >
              <TextArea autoSize />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderBottom: '1px solid #d9d9d9' }}
            >
              Документ на право подписи уполномоченного лица со стороны
              Грантополучателя (указывается с большой буквы) (в
              {' '}
              <b>родительном падеже</b>
              )
              <div
                style={{
                  marginTop: '16px',
                  fontStyle: 'italic',
                  fontSize: 12,
                }}
              >
                Указывается при наличии
              </div>
            </div>
            <Form.Item
              style={{ width: '100%' }}
              name="osnovanie"
              initialValue={coexecutorData?.osnovanie || ''}
            >
              <TextArea autoSize onChange={(e) => setOsnovanieName(e.target.value)} />
            </Form.Item>
          </div>

          {osnovanieName?.length > 0 && (
          <div className="application-main-box-content-wrapper">
            <Dragger
              showUploadList={false}
              onChange={onUploadFile}
              disabled={loading}
              multiple
              action={null}
            >
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p
                className="ant-upload-text"
                style={{
                  fontStyle: 'normal',
                  fontWeight: 700,
                  fontSize: 18,
                }}
              >
                Файл документа, подтверждающий право подписи
                уполномоченного лица, необходимо прикрепить, если
                используется любой документ
              </p>
              <p className="ant-upload-text">
                Выберите или перенесите файл, чтобы загрузить (не более
                15мб). Для прикрепления нескольких файлов осуществляйте их
                загрузку по очереди, а не одновременно
              </p>
            </Dragger>
            {osnovanieFile && (
            <Row style={{ margin: '5px 0px' }} gutter={12}>
              <Col>
                <DownloadOutlined
                  style={{ cursor: 'pointer' }}
                  onClick={() => window.open(osnovanieFile.urlLink)}
                />
              </Col>
              {!loading && (
              <Col>
                <DeleteOutlined
                  style={{ cursor: 'pointer' }}
                  onClick={onDeleteFile}
                />
              </Col>
              )}
              <Col>
                {osnovanieFile.name || osnovanieFile.originalFileName}
              </Col>
            </Row>
            )}
          </div>

          )}

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderBottom: '1px solid #d9d9d9' }}
            >
              Вид работ
            </div>
            <Form.Item
              style={{ width: '100%' }}
              name="workType"
              initialValue={coexecutorData.workType || 'workTypeNIR' }
            >
              <Select onSelect={(value) => setWorkType(value)}>
                <Option value="workTypeNIR">
                  Научно-исследовательская работа
                </Option>
                <Option value="workTypeNIOKR">
                  Научно-исследовательская и опытно-конструкторская работа
                </Option>
              </Select>
            </Form.Item>
          </div>

          {workType === 'workTypeNIOKR' && (
          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderBottom: '1px solid #d9d9d9' }}
            >
              Укажите какой образец(-цы) должен(-ны) быть разработан(-ы)
            </div>
            <Form.Item
              style={{ width: '100%' }}
              name="sampleType"
              initialValue={coexecutorData.sampleType}
            >
              <TextArea autoSize />
            </Form.Item>
          </div>
          )}

          <hr style={{ margin: '40px 0px' }} />

          <div className="common-subTitle" style={{ fontSize: '20px' }}>
            <b>Банковские реквизиты Грантополучателя</b>
          </div>
          <div
            className="common-subTitle"
            style={{ fontSize: '16px', fontStyle: 'italic' }}
          >
            <b>
              Укажите в соответствии с учетной карточкой (реквизитов)
              организации
            </b>
          </div>

          <div className="common-table-wrapper">
            <div className="common-table-row">
              <div className="common-table-row-cell">ОГРН</div>
              <Form.Item
                style={{ width: '100%' }}
                name="ogrn"
                initialValue={coexecutorData?.ogrn || coexecutorData.coexecutorsPersonId.ogrn}
              >
                <Input />
              </Form.Item>
            </div>
            <div className="common-table-row">
              <div className="common-table-row-cell">ИНН</div>
              <Form.Item
                style={{ width: '100%' }}
                name="inn"
                initialValue={coexecutorData?.inn || coexecutorData.coexecutorsPersonId.inn}
              >
                <Input />
              </Form.Item>
            </div>

            <div className="common-table-row">
              <div className="common-table-row-cell">КПП</div>
              <Form.Item
                style={{ width: '100%' }}
                name="kpp"
                initialValue={coexecutorData?.kpp || ''}
              >
                <Input />
              </Form.Item>
            </div>
            <div className="common-table-row">
              <div className="common-table-row-cell">Получатель</div>
              <Form.Item
                style={{ width: '100%' }}
                name="poluchatel"
                initialValue={coexecutorData?.poluchatel || ''}
              >
                <Input />
              </Form.Item>
            </div>
            <div className="common-table-row">
              <div
                className="common-table-row-cell"
                style={{ borderBottom: '1px solid #d9d9d9' }}
              >
                Юридический адрес:
                {' '}
              </div>
              <Form.Item
                style={{ width: '100%' }}
                name="urAddress"
                initialValue={coexecutorData?.urAddress || ''}
              >
                <Input />
              </Form.Item>
            </div>
            <>
              <div className="common-table-row">
                <div
                  className="common-table-row-cell"
                  style={{ borderBottom: '1px solid #d9d9d9' }}
                >
                  Наименование банка:
                </div>
                <Form.Item
                  style={{ width: '100%' }}
                  name="bank"
                  initialValue={coexecutorData?.bank || ''}
                >
                  <Input />
                </Form.Item>
              </div>

              <div className="common-table-row">
                <div
                  className="common-table-row-cell"
                  style={{ borderBottom: '1px solid #d9d9d9' }}
                >
                  Р/с:
                  {' '}
                </div>
                <Form.Item
                  style={{ width: '100%' }}
                  name="rs"
                  initialValue={coexecutorData?.rs || ''}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="common-table-row">
                <div
                  className="common-table-row-cell"
                  style={{ borderBottom: '1px solid #d9d9d9' }}
                >
                  К/с:
                  {' '}
                </div>
                <Form.Item
                  style={{ width: '100%' }}
                  name="ks"
                  initialValue={coexecutorData?.ks || ''}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="common-table-row">
                <div
                  className="common-table-row-cell"
                  style={{ borderBottom: '1px solid #d9d9d9' }}
                >
                  БИК:
                  {' '}
                </div>
                <Form.Item
                  style={{ width: '100%' }}
                  name="biq"
                  initialValue={coexecutorData?.biq || ''}
                >
                  <Input />
                </Form.Item>
              </div>
              <div className="common-table-row">
                <div
                  className="common-table-row-cell"
                  style={{ borderBottom: '1px solid #d9d9d9' }}
                >
                  ОКТМО:
                  {' '}
                </div>
                <Form.Item
                  style={{ width: '100%' }}
                  name="oktmo"
                  initialValue={coexecutorData?.oktmo || ''}
                >
                  <Input />
                </Form.Item>
              </div>
            </>

            <div className="common-table-row">
              <div
                className="common-table-row-cell"
                style={{ borderBottom: '1px solid #d9d9d9' }}
              >
                Дополнительная информация:
                {' '}
                <div
                  style={{
                    marginTop: '16px',
                    fontStyle: 'italic',
                    fontSize: 12,
                  }}
                >
                  При необходимости укажите электронную почту, факс или
                  телефон
                </div>
              </div>
              <Form.Item
                style={{ width: '100%' }}
                name="otherInfoRequisits"
                initialValue={coexecutorData?.otherInfoRequisits || ''}
              >
                <TextArea placeholder="Введите текст" autoSize />
              </Form.Item>
            </div>

            <div className="application-main-box-content-wrapper">
              <Dragger
                showUploadList={false}
                onChange={onUploadOrganizationCardFile}
                disabled={loading}
                multiple
                action={null}
              >
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p
                  className="ant-upload-text"
                  style={{
                    fontStyle: 'normal',
                    fontWeight: 700,
                    fontSize: 18,
                  }}
                >
                  Учетная карточка организации
                </p>
                <p className="ant-upload-text">
                  Выберите или перенесите файл, чтобы загрузить (не более
                  15мб). Для прикрепления нескольких файлов осуществляйте их
                  загрузку по очереди, а не одновременно
                </p>
              </Dragger>
              {organizationCardFile && (
              <Row style={{ margin: '5px 0px' }} gutter={12}>
                <Col>
                  <DownloadOutlined
                    style={{ cursor: 'pointer' }}
                    onClick={() => window.open(organizationCardFile.urlLink)}
                  />
                </Col>
                {!loading && (
                <Col>
                  <DeleteOutlined
                    style={{ cursor: 'pointer' }}
                    onClick={onDeleteOrganizationCardFile}
                  />
                </Col>
                )}
                <Col>
                  {organizationCardFile.name || organizationCardFile.originalFileName}
                </Col>
              </Row>
              )}
            </div>
          </div>

          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="stepTotalPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.stepTotal,
            )}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step1YearPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step1Sum
                              + coexecutorData.coexecutorsPersonId.step2Sum,
            )}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step1SumPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step1Sum,
            )}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step2SumPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step2Sum,
            )}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step2YearPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step3Sum
                              + coexecutorData.coexecutorsPersonId.step4Sum,
            )}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step3SumPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step3Sum,
            )}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step4SumPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step4Sum,
            )}
          >
            <Input />
          </Form.Item>

          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step3YearPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step5Sum
                              + coexecutorData.coexecutorsPersonId.step6Sum,
            )}
          >
            <Input />
          </Form.Item>

          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step5SumPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step5Sum,
            )}
          >
            <Input />
          </Form.Item>
          <Form.Item
            hidden
            style={{ width: '100%' }}
            name="step6SumPropis"
            initialValue={getWordedNumber(
              coexecutorData.coexecutorsPersonId.step6Sum,
            )}
          >
            <Input />
          </Form.Item>
        </div>

        <div
          className="common-sub-title"
          style={{ fontSize: '18px', marginBottom: '20px' }}
        >
          <b>
            Техническое задание на выполнение научно-исследовательских
            работ (НИР) и/или научно-исследовательских,
            опытно-конструкторских и технологических работ (НИОКР)
          </b>
        </div>
        <div className="common-table-wrapper">
          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Термины и определения
            </div>
            <Form.Item
              name="tz_terms_definitions"
              initialValue={coexecutorData.tz_terms_definitions || ''}
              style={{ width: '100%', color: '#000' }}
            >
              <TextArea autoSize />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Цель выполнения работ
            </div>
            <Form.Item style={{ width: '100%' }}>
              <TextArea
                value={parseJsonResponse(
                  'tz_target',
                  coexecutorData.coexecutorsPersonId.meri_podderjki,
                )}
                disabled
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Задачи, подлежащие решению в результате выполнения работ
            </div>
            <Form.Item style={{ width: '100%' }}>
              <TextArea
                value={parseJsonResponse(
                  'tz_tasks',
                  coexecutorData.coexecutorsPersonId.meri_podderjki,
                )}
                disabled
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Перечень результатов, подлежащих получению по факту
              завершения выполнения работ
            </div>
            <Form.Item style={{ width: '100%' }}>
              <TextArea
                value={parseJsonResponse(
                  'tz_results',
                  coexecutorData.coexecutorsPersonId.meri_podderjki,
                )}
                disabled
                autoSize
              />
            </Form.Item>
          </div>

          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Технические требования к научно-техническим результатам
              работ
            </div>
            <Form.Item style={{ width: '100%' }}>
              <TextArea
                value={parseJsonResponse(
                  'tz_technical_requirements',
                  coexecutorData.coexecutorsPersonId.meri_podderjki,
                )}
                disabled
                autoSize
              />
            </Form.Item>
          </div>
          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderRight: '1px solid #d9d9d9' }}
            >
              Перечень разрабатываемой документации и требования к ее
              оформлению
            </div>
            <Form.Item style={{ width: '100%' }}>
              <TextArea
                value={parseJsonResponse(
                  'tz_documents_requirements',
                  coexecutorData.coexecutorsPersonId.meri_podderjki,
                )}
                disabled
                autoSize
              />
            </Form.Item>
          </div>
          <div className="common-table-row">
            <div
              className="common-table-row-cell"
              style={{ borderBottom: '1px solid #d9d9d9' }}
            >
              Этапы работ и сроки их выполнения
            </div>
            <Form.Item style={{ width: '100%' }}>
              <TextArea
                disabled
                value={parseJsonResponse(
                  'tz_stages',
                  coexecutorData.coexecutorsPersonId.meri_podderjki,
                )}
                autoSize
              />
            </Form.Item>
          </div>
        </div>

        <hr style={{ margin: '40px 0px' }} />

        <Plan coexecutorData={coexecutorData} formRef={formRef} />

        <hr style={{ margin: '40px 0px' }} />

        <Smeta coexecutorData={coexecutorData} formRef={formRef} />
      </div>

      <Button
        type="primary"
        onClick={onSaveForm}
        style={{ marginTop: '15px' }}
      >
        Сохранить
      </Button>
    </Card>
  );
};

SProject.propTypes = {
  coexecutorData: PropTypes.shape().isRequired,
  formRef: PropTypes.shape().isRequired,
  onSaveForm: PropTypes.func.isRequired,
};
